import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReleaseHistoryPage } from './pages/release-history/release-history.page';
import { RegisterNfcTagPage } from './pages/register-nfc-tag/register-nfc-tag.page';
import { PrintJobsPage } from './pages/print-jobs/print-jobs.page';
import { PrinterListPage } from './pages/printer-list/printer-list.page';
import { GoPage } from './pages/go/go.page';
import { LoginPage } from './pages/auth/login/login.page';
import { NetworkCheckPage } from './pages/auth/network-check/network-check.page';
import { TenantSelectPage } from './pages/auth/tenant-select/tenant-select.page';
import { CaptureHistoryPage } from './pages/capture-history/capture-history.page';
import { CapturePage } from './pages/capture/capture.page';
import { authGuard } from './services/auth/auth.guard';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'network-check',
    pathMatch: 'full'
  },
  {
    path: 'network-check',
    component: NetworkCheckPage,
    data: { title: '' }
  },
  {
    path: 'print-jobs',
    component: PrintJobsPage,
    data: { title: 'Print' },
    canActivate: [authGuard]
  },
  {
    path: 'printer-list',
    component: PrinterListPage,
    data: { title: 'Printers' },
    canActivate: [authGuard]
  },
  {
    path: 'capture',
    component: CapturePage,
    data: { title: 'Capture' },
    canActivate: [authGuard]
  },
  {
    path: 'recents',
    component: PrintJobsPage,
    data: { title: 'Recents' },
    canActivate: [authGuard]
  },
  {
    path: 'release-history',
    component: ReleaseHistoryPage,
    data: { title: 'PrintHistory' },
    canActivate: [authGuard]
  },
  {
    path: 'capture-history',
    component: CaptureHistoryPage,
    data: { title: 'CaptureHistory' },
    canActivate: [authGuard]
  },
  {
    path: 'tenant-select',
    component: TenantSelectPage,
    data: { title: 'ChangeHome' },
    canActivate: [authGuard]
  },
  {
    path: 'go',
    component: GoPage,
    data: { title: 'CardsAndCodes' },
    canActivate: [authGuard]
  },
  {
    path: 'register-nfc-tag',
    component: RegisterNfcTagPage,
    data: { title: 'RegisterNfcTag' },
    canActivate: [authGuard]
  },
  {
    path: 'sign-in',
    component: LoginPage,
    data: { title: '' }
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }